<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content>
  <span *ngIf="!isObject">{{message}}</span>
  <app-json-formatter *ngIf="isObject" [data]="message" [levelsOpen]="levelsOpen"></app-json-formatter>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="accent" mat-dialog-close i18n>OK</button>
</mat-dialog-actions>
